
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/businesses/[type]/[slug]",
      function () {
        return require("private-next-pages/businesses/[type]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/businesses/[type]/[slug]"])
      });
    }
  